export default {
    joinMeetingTemp: null
};